<script>
/**
 * Stat component -- specify the widget icon, title and value.
 */
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: ""
    },
    value2: {
      type: String,
      default: ""
    },
    value3: {
      type: String,
      default: ""
    },
    value2Size: {
      type: Number,
      default: 0
    },
    icon: {
      type: String,
      default: ""
    }
  }
};
</script>

<template>
  <div class="card mini-stats-wid" style="bo">
    <div class="card-body" style="background: #EFF7FB; border-radius: 30px; box-shadow: 0 2px 4px #C2C9CD;">
      <div class="media">
        <div class="media-body">
          <p class="text-muted fw-medium mb-2">{{title}}</p>
          <div v-if="value2 != ''" style="height: 60px;">
            <h4 class="mb-0">{{value}}</h4>
            <template v-if="value2Size == 0">
              <h6 class="mt-2">{{value3 != '' ? `${value2} (${value3})` : `${value2}`}}</h6>
              <!-- <h6 v-if="value3 != ''" class="mt-2">{{value2}}</h6> -->
            </template>
            <template v-else>
              <h6 class="mt-2" :style="`font-size: ${value2Size}pt;`">{{value2}}</h6>
            </template> 
          </div>
          <div v-else style="height: 60px;">
            <h2 class="mb-0" >{{value}}</h2>
            <!-- <h5 class="mt-2" style="color: white;">00</h5> -->
          </div>
          
        </div>

        <div class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary">
          <span class="avatar-title">
            <i :class="`${icon} font-size-24`"></i>
          </span>
        </div>
      </div>
    </div>
    <!-- end card-body -->
  </div>
  <!-- end card -->
</template>